import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import qSelectionObject from '../hooks/qSelectionObject'
import { Button, List, ListItem, ListItemIcon, Chip, ListItemText } from '@material-ui/core'
import * as Icon from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '../../../utils/Theme'
import clsx from 'clsx'
const globalTheme = Theme()
const useStyles = makeStyles({
  ...globalTheme,
  root: {
    width: '100%',
    ...globalTheme.backgroundLight,
  },
  icon: {
    minWidth: '32px !important',
  },
  chip: {
    marginLeft: 5,
    marginBottom: 5,
  },
})

const QDocSelections = ({ qDocPromise, cols, qPage, options, title, btnText, getData }) => {
  const { qLayout, clearSelections } = qSelectionObject({
    qDocPromise,
    cols,
    qPage,
    options,
  })
  // const [open, setOpen] = useState(false)
  let selections = []

  const handleCallback = useCallback(() => {
    return getData(qLayout, [getData, qLayout])
  }, [getData, qLayout])

  if (qLayout) {
    const selectedFields = qLayout.qSelectionObject.qSelections
    if (selectedFields.length) {
      selections = selectedFields.map(value => {
        if (value.qSelectedCount >= 1 && value.qSelectedCount <= 6) {
          return {
            field: value.qReadableName || value.qField,
            selected: value.qSelectedFieldSelectionInfo.map(valueInner => valueInner.qName),
            total: value.qTotal,
          }
        }
        if (value.qSelectedCount > 6) {
          return {
            field: value.qField,
            selected: [`${value.qSelectedCount} of ${value.qTotal}`],
            hideOnDelete: true,
          }
        }
        return null
      })
    }
  }

  useEffect(() => {
    if (qLayout && getData) {
      handleCallback()
    }
  }, [getData, handleCallback, qLayout])

  const classes = useStyles()

  return (
    <div className={clsx(classes.root)}>
      <List component={'nav'} aria-label={'Selections Menu'}>
        <span className={clsx('c-sidebar__title')} style={{ marginLeft: 4, border: 'none' }}>
          {title}
        </span>
        {selections.length >= 1 &&
          selections.length <= 6 &&
          selections.map(value => {
            return (
              <ListItem button key={value.field}>
                <ListItemIcon className={classes.icon}>
                  <Icon.HighlightOff onClick={() => clearSelections(value.field)} />
                </ListItemIcon>
                <ListItemText>
                  <span style={{ marginRight: 5 }}>
                    <b>{value.field}: </b>
                  </span>
                  {value.selected.map((dropdown_value, index) => {
                    return (
                        <Chip
                        key={index}
                          clickable
                          color='primary'
                          variant={'outlined'}
                          className={classes.chip}
                          label={dropdown_value}
                          size={'small'}
                          deleteIcon={<Icon.HighlightOff size={8}/>}
                          onDelete={() => clearSelections(value.field, !value.hideOnDelete && dropdown_value)}
                        />

                    )
                  })}
                </ListItemText>
              </ListItem>
            )
          })}
        {selections.length > 0 && (
          <ListItem className={'u-text-center'}>
            <Button
              className={clsx(classes.buttonPrimary, 'c-btn--fullwidth')}
              size={'small'}
              onClick={() => clearSelections()}
            >
              {btnText || 'Clear All'}
            </Button>
          </ListItem>
        )}
      </List>
    </div>
  )
}

QDocSelections.propTypes = {
  qDocPromise: PropTypes.object.isRequired,
  cols: PropTypes.array,
  options: PropTypes.object,
  qPage: PropTypes.object,
  title: PropTypes.string,
  btnText: PropTypes.string,
  getData: PropTypes.func,
}

QDocSelections.defaultProps = {
  cols: [],
  options: { qType: 'SelectionObject' },
  qPage: {
    qTop: 0,
    qLeft: 0,
    qWidth: 1,
    qHeight: 1,
  },
  title: 'SELECTIONS',
  btnText: 'Clear All',
  getData: null,
}

export default QDocSelections
